import * as tslib_1 from "tslib";
import { AttributesBuffer } from "@awayjs/core";
import { TriangleElements } from "@awayjs/graphics";
import { GL_RenderableBase } from "@awayjs/stage";
import { GL_SkyboxElements } from "../elements/GL_SkyboxElements";
/**
 * @class away.pool.GL_SkyboxRenderable
 */
var GL_SkyboxRenderable = (function (_super) {
    tslib_1.__extends(GL_SkyboxRenderable, _super);
    /**
     * //TODO
     *
     * @param pool
     * @param skybox
     */
    function GL_SkyboxRenderable(skybox, renderablePool) {
        var _this = _super.call(this, skybox, renderablePool) || this;
        _this._skybox = skybox;
        return _this;
    }
    /**
     * //TODO
     *
     * @returns {away.base.TriangleElements}
     * @private
     */
    GL_SkyboxRenderable.prototype._getElements = function () {
        var elementsGL = GL_SkyboxRenderable._elementsGL;
        if (!elementsGL) {
            var elements = new TriangleElements(new AttributesBuffer(11, 4));
            elements.autoDeriveNormals = false;
            elements.autoDeriveTangents = false;
            elements.setIndices(Array(0, 1, 2, 2, 3, 0, 6, 5, 4, 4, 7, 6, 2, 6, 7, 7, 3, 2, 4, 5, 1, 1, 0, 4, 4, 0, 3, 3, 7, 4, 2, 1, 5, 5, 6, 2));
            elements.setPositions(Array(-1, 1, -1, 1, 1, -1, 1, 1, 1, -1, 1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1));
            elementsGL = GL_SkyboxRenderable._elementsGL = new GL_SkyboxElements(elements, this._stage);
        }
        return elementsGL;
    };
    GL_SkyboxRenderable.prototype._getMaterial = function () {
        return this._materialGroup.getMaterialPool(this.elementsGL).getAbstraction(this._skybox);
    };
    GL_SkyboxRenderable._includeDependencies = function (shader) {
    };
    return GL_SkyboxRenderable;
}(GL_RenderableBase));
export { GL_SkyboxRenderable };



// WEBPACK FOOTER //
// ../dist/lib/renderables/GL_SkyboxRenderable.js